import { render, staticRenderFns } from "./table.pnd54.vue?vue&type=template&id=5bcb60f4"
import script from "./table.pnd54.vue?vue&type=script&lang=js"
export * from "./table.pnd54.vue?vue&type=script&lang=js"
import style0 from "./table.pnd54.vue?vue&type=style&index=0&id=5bcb60f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports